import React from 'react';

import { StyledCard } from './Card.styles';

import { CardProps } from './Card.types';

import { Image } from '../../../';

const Card = ({
  image,
  content,
  componentClassname = 'card',
  customClassnames = '',
  customStyle = '',
  ...props
}: CardProps) => {
  return (
    <StyledCard
      className={`${componentClassname} ${customClassnames}`}
      customStyle={customStyle}
      {...props}
    >
      {image?.url && (
        <Image
          src={image.url}
          alt={image.alt}
          imageWidth={image.width}
          imageHeight={image.height}
          className={`${componentClassname}__image`}
        />
      )}
      <div className={`${componentClassname}__content`}>{content}</div>
    </StyledCard>
  );
};
Card.displayName = 'Card';

export default Card;
